import React from 'react'
import CommonFetch from '../../../requests/commonFetch'

const postData = props => {
    let {
        tfaCode = '',
        personalDataChanged = {},
        userDataChanged = {},
        dataChangedSuccess,
        changeNotificationStatus,
        dataProtection,
    } = props

    let userDataRequestOption = {
        userDataChanged: userDataChanged,
        dataChangedSuccess: dataChangedSuccess,
        changeNotificationStatus: changeNotificationStatus,
        dataProtection: dataProtection,
    }

    let personalDataChangedLength = Object.keys(personalDataChanged).length
    let userDataChangedLength = Object.keys(userDataChanged).length

    let formData = new FormData()

    if (tfaCode) {
        formData.append('2fa_code', tfaCode)
    }

    let data = personalDataChangedLength ? personalDataChanged : userDataChanged

    for (let item in data) {
        formData.append(item, data[item])
    }

    CommonFetch({
        path: tfaCode
            ? 'ui/investor_settings/post_personaldata'
            : 'ui/investor_settings/post_userdata',
        method: 'POST',
        data: formData,
    }).then(data => {
        if (data.success) {
            if (
                personalDataChangedLength === 0 ||
                userDataChangedLength === 0
            ) {
                dataChangedSuccess()
                changeNotificationStatus({
                    type: 'success',
                    description: 'Your changes are saved',
                })
                dataProtection('update')
            } else {
                postData(userDataRequestOption)
            }
        } else if (
            data.error === 'wrong_arguments' &&
            userDataChangedLength !== 0
        ) {
            postData(userDataRequestOption)
        } else {
            if (data.error === 'wrong_2fa_code') {
                changeNotificationStatus({
                    type: 'error',
                    description: 'Wrong code',
                })
            }
        }
    })
}

export default postData
